export default function getSslCertificateReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_SSL_CERTIFICATES_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_SSL_CERTIFICATES_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_SSL_CERTIFICATES_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}